import { render } from "./DisclaimerComponent.vue?vue&type=template&id=28e348c8&scoped=true"
import script from "./DisclaimerComponent.vue?vue&type=script&lang=js"
export * from "./DisclaimerComponent.vue?vue&type=script&lang=js"

import "./DisclaimerComponent.vue?vue&type=style&index=0&id=28e348c8&scoped=true&lang=css"

import exportComponent from "/tmp/build_905a1b4c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e348c8"]])

export default __exports__